var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCssIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#1c87c6;}.cls-3{fill:#1b73b9;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m131.88,378.44l-23.76-290.39,283.77.58-25.13,289.8-115.69,33.5-119.19-33.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m251.07,383.9V115.71l116.86.39-20.84,239.95-96.02,27.85Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m338.91,149.99h-179.77l4.87,35.05h85.3l-83.94,36.03,4.87,33.89h123.68l-4.48,47.33-41.87,8.18-37.98-9.74-2.92-26.88h-34.86l4.67,55.9,74.79,20.84,71.67-22.79,9.15-109.26h-75.77l82.58-34.28v-34.28Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCssIcon);
export default __webpack_public_path__ + "static/media/css_icon.604771ddfc62c455d5d34638b486c1b0.svg";
export { ForwardRef as ReactComponent };